import React, { useEffect, useState } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { convertDateToEODTimestamp } from "../../../utils/dateutils";

dayjs.extend(utc);

const DatePickerMui = ({ data, setData, inputFieldSyle, name, label }) => {
  const [state, setState] = useState(null);

  useEffect(() => {
    if (data?.[name]) {
      setState(dayjs(data?.[name]));
    }
  }, [data?.[name]]);
  
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker"]}>
        <DatePicker
          label={label}
          className="date-picker-mui"
          onChange={(value) => {
            setState(value);
            setData(prev=>({
              ...prev,
              [name]: convertDateToEODTimestamp(new Date(value)),
            }));
          }}
          value={state}
          sx={inputFieldSyle}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};

export default DatePickerMui
